angular.module('NumbersEditor')
    .controller('SetupSportCodeController', [
        '$scope', 'SportCodeFactory', 'authFactory', '$location', '$rootScope', '$dialogs', '$document', '$route', 'sportCodeService',
        function ($scope, sportCodeFactory, authFactory, $location, $rootScope, $dialogs, $document, $route, sportCodeService) {

            init();

            function init() {
                $scope.ShowAddButton = false;
                if (authFactory.GetAuthenticationData().isAdmin) {
                    $rootScope.SetAppTitle("Setup Sport Codes", "Setup Sport Codes");
                    getSportCodes();
                    getAvailableSportCodeList();
                } else {
                    $location.path("");
                }
            };

            function getSportCodes() {
                sportCodeService.getSportCodes()
                    .then(function (sportCodes) {
                        $scope.SportCodes = sportCodes;
                    })
                    .catch(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            };

            $scope.EditSportCode = function (sportCode) {
                $location.path("sportcodeedit/" + sportCode);
            };

            $scope.AddSportCode = function () {
                $location.path("sportcodeadd");
            };

            $scope.DeleteSportCode = function (sportCode) {
                var dlg = $dialogs.confirm('Please Confirm', 'Are you sure you want to delete this sport code?');
                dlg.result.then(function (btn) {
                    sportCodeFactory.deleteSportCode(sportCode)
                        .success(function () {
                            $route.reload();
                            $.message(MessageText.SportCodeSuccessfullyDeleted, MessageType.Success);
                        })
                        .error(function (error) {
                            $.message(error.ExceptionMessage, MessageType.Error);
                        });
                });
            };

            function getAvailableSportCodeList() {
                sportCodeService.getSportCode('0')
                    .then(function (sportCodes) {
                        if (sportCodes.SportCodeList.length > 0) {
                            $scope.ShowAddButton = true;
                        }
                    })
                    .catch(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            };
        }
    ]);